import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Collapsible, Typography, getTestId, useBreakpoint, isValidObject, Tooltip, InfoIcon, BLUE_500, tokens } from '@airtel/air-design-system';
import { useState } from 'react';
import { Pressable, View } from 'react-native';
import { getLeftRightListItemData, getInvestmentDetailsWidgetStyles } from '../../InvestmentDetailsWidgetStyles';
export var InvestmentBreakupItem = props => {
  var leftDetails = props.leftDetails,
    isAccordian = props.isAccordian,
    accordianList = props.accordianList,
    rightDetails = props.rightDetails,
    containerStyle = props.containerStyle,
    leftTypographyStyle = props.leftTypographyStyle,
    rightTypographyStyle = props.rightTypographyStyle,
    testID = props.testID,
    _props$showInfoIcon = props.showInfoIcon,
    showInfoIcon = _props$showInfoIcon === void 0 ? false : _props$showInfoIcon,
    toolTipProps = props.toolTipProps,
    accessibilityProps = props.accessibilityProps,
    collapsibleProps = props.collapsibleProps;
  var _useBreakpoint = useBreakpoint({
      allowMdAsLargeScreen: true,
      returnAsObject: true
    }),
    isSmallScreen = _useBreakpoint.isSmallScreen;
  var investmentBreakupItemStyles = getInvestmentDetailsWidgetStyles();
  var _useState = useState(false),
    showToolTip = _useState[0],
    setShowTooltip = _useState[1];
  var showAccordianView = isAccordian && (accordianList === null || accordianList === void 0 ? void 0 : accordianList.length) > 0;
  if (isValidObject(leftDetails)) {
    leftDetails.isBold = !!isAccordian || (leftDetails === null || leftDetails === void 0 ? void 0 : leftDetails.isBold);
  }
  if (isValidObject(rightDetails)) {
    rightDetails.isBold = !!isAccordian || (rightDetails === null || rightDetails === void 0 ? void 0 : rightDetails.isBold);
  }
  var leftRightItemData = getLeftRightListItemData(props, isSmallScreen);
  var onInfoIconPress = setShowTooltip => {
    setShowTooltip(!showToolTip);
  };
  var getContent = () => {
    var _a, _b;
    return _jsxs(View, Object.assign({
      style: [investmentBreakupItemStyles.listContainer, showAccordianView ? investmentBreakupItemStyles.collapsibleContainer : investmentBreakupItemStyles.nonCollapsibleContainer, containerStyle]
    }, {
      children: [_jsxs(View, Object.assign({
        style: investmentBreakupItemStyles.leftDetailsContainer
      }, {
        children: [_jsxs(View, Object.assign({
          style: investmentBreakupItemStyles.leftDetailsItemContainer
        }, {
          children: [!!(leftDetails === null || leftDetails === void 0 ? void 0 : leftDetails.text) && _jsx(Typography, Object.assign({
            text: leftDetails === null || leftDetails === void 0 ? void 0 : leftDetails.text,
            title: leftDetails === null || leftDetails === void 0 ? void 0 : leftDetails.title,
            type: leftRightItemData === null || leftRightItemData === void 0 ? void 0 : leftRightItemData.leftItemFontType,
            color: leftRightItemData === null || leftRightItemData === void 0 ? void 0 : leftRightItemData.rightItemColor,
            style: leftTypographyStyle
          }, getTestId(testID, 'leftTitleText'))), !!showInfoIcon && !!(toolTipProps === null || toolTipProps === void 0 ? void 0 : toolTipProps.text) && _jsx(Tooltip, Object.assign({
            text: (_a = toolTipProps === null || toolTipProps === void 0 ? void 0 : toolTipProps.text) !== null && _a !== void 0 ? _a : '',
            position: "top-start",
            offset: {
              x: -10,
              y: -6
            },
            isVisible: showToolTip,
            onClose: () => {
              setShowTooltip(false);
            },
            showCross: true,
            style: investmentBreakupItemStyles.infoIconTooltip,
            testID: (_b = toolTipProps === null || toolTipProps === void 0 ? void 0 : toolTipProps.id) !== null && _b !== void 0 ? _b : 'InfoList-Child-RightToolTip',
            autoHide: true,
            autoHideTimeout: 5000
          }, toolTipProps, getTestId(testID, 'toolTip')))]
        })), !!showInfoIcon && _jsx(Pressable, Object.assign({
          onPress: () => onInfoIconPress(setShowTooltip)
        }, {
          children: _jsx(InfoIcon, Object.assign({
            color: BLUE_500,
            fontSize: tokens.spacing.SPACING_16,
            accessibilityLabel: "info icon"
          }, getTestId(testID, 'infoIcon')))
        }))]
      })), _jsx(View, Object.assign({
        style: [investmentBreakupItemStyles.rightDetailsItemContainer]
      }, {
        children: !!(rightDetails === null || rightDetails === void 0 ? void 0 : rightDetails.text) && _jsx(Typography, Object.assign({
          text: rightDetails === null || rightDetails === void 0 ? void 0 : rightDetails.text,
          title: rightDetails === null || rightDetails === void 0 ? void 0 : rightDetails.title,
          type: leftRightItemData === null || leftRightItemData === void 0 ? void 0 : leftRightItemData.rightItemFontType,
          color: leftRightItemData === null || leftRightItemData === void 0 ? void 0 : leftRightItemData.rightItemColor,
          style: rightTypographyStyle
        }, getTestId(testID, 'rightTitleText')))
      }))]
    }));
  };
  if (showAccordianView) {
    return _jsx(Collapsible, Object.assign({
      titleNoHorizontalPadding: true,
      titleNoVerticalPadding: true,
      childNoVerticalPadding: true,
      childNoHorizontalPadding: true,
      titleComponent: getContent(),
      version: "variable-width"
    }, accessibilityProps, collapsibleProps, {
      style: investmentBreakupItemStyles.accordianContainerWrapper
    }, {
      children: _jsx(View, Object.assign({
        style: investmentBreakupItemStyles.accordianContainer
      }, {
        children: accordianList === null || accordianList === void 0 ? void 0 : accordianList.map((item, index) => {
          return _jsx(InvestmentBreakupItem, Object.assign({}, item, {
            testID: testID + "_listItem_" + index
          }), "investment_breakup_" + index);
        })
      }))
    }));
  }
  return getContent();
};